import styled from 'styled-components/native';
import {Dimensions} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';

interface CheckProps {
  checked: boolean;
  isLatest?: boolean;
}

const {width} = Dimensions.get('window');
const containerWidth = width - RFValue(48);
const marginBetweenSquares = 6;
const containerPadding = RFValue(12);
const squareWidth =
  (containerWidth - RFValue(containerPadding * 2)) / 7 - marginBetweenSquares;

export const Container = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const SquareSeparator = styled.View<CheckProps>`
  flex-grow: 1;
  height: 2px;
  background-color: ${({checked, theme}) =>
    checked ? theme.colors.banner_green : theme.colors.gold};
`;

export const Square = styled.View<CheckProps>`
  width: ${({isLatest = false}) =>
    isLatest ? `${squareWidth - 4}px` : `${squareWidth}px`};
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  height: 100%;
  background-color: ${({checked, theme}) =>
    checked ? theme.colors.primary : '#fcf0d2'};
`;

export const DayText = styled.Text<CheckProps>`
  font-size: ${squareWidth * 0.25}px;
  margin-top: -${RFValue(8)}px;
  padding-bottom: ${RFValue(8)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({checked, theme}) =>
    checked ? theme.colors.shape : theme.colors.orange};
`;
